import { Stage } from '@eventbrite/webapp-constants';

//General Constants
export const AWS_REGION = 'us-east-1';
export const FIND_MY_TICKET = 'Find My Ticket';
export const HELP_CENTER = 'Help Center';
export const LOGIN = 'Log In';
export const SIGN_UP = 'Sign up';
export const EVENTBRITE = 'Eventbrite';

export const EB_HOME_URL = {
  [Stage.PROD]: 'https://www.eventbrite.com',
  [Stage.DEV]: 'https://www.evbqa.com',
  [Stage.TEST]: 'https://www.evbqa.com',
  [Stage.LOCAL]: 'https://www.evbqa.com',
};

// export const LOGIN_URL = `${EB_HOME_URL[stage]}/signin/?referrer=%2Fmytickets%2F`;
// export const SIGN_UP_URL = `${EB_HOME_URL[stage]}/signin/signup/`;
// export const RESET_PASSWORD_URL = `${EB_HOME_URL[stage]}/reset-password`;
// export const MY_TICKETS_URL = `${EB_HOME_URL[stage]}/mytickets`;
// export const HELP_CENTER_URL = `${EB_HOME_URL[stage]}/help/en-us`;
// export const HELP_CENTER_YOUR_TICKETS = `${HELP_CENTER_URL}/articles/319355/where-are-my-tickets/`;
// export const HELP_CENTER_DUPLICATE_CHARGES = `${HELP_CENTER_URL}/articles/103000/why-was-i-charged-multiple-times-for-an-event/`;
// export const CONTACT_ORGANIZER_URL = `${HELP_CENTER_URL}/articles/647151/how-to-contact-the-event-organizer/`;
// export const SEARCH_EVENTS_URL = `${EB_HOME_URL[stage]}/d/local/events/`;
// export const AUTH0_URL = `${EB_HOME_URL}/api/v3/pre_auth/?email={email_id}&universal_login=true&referrer=%2Fmytickets`;

export const INTERNAL_SERVER_ERROR = 'Internal Server Error';
export const ERROR_MESSAGE = 'Something went wrong. Please try again.';
export const EMAIL_VALIDATION_MESSAGE = 'Please enter a valid email address.';
export const EMAIL_SENT_MESSAGE = 'Email sent successfully.';
export const NETWORK_ERROR_MESSAGE = 'Network response was not ok';
export const INVALID_DATE_ERROR_MESSAGE = 'Invalid date format. Please use MM/DD/YYYY.';
export const INVALID_DATE_ERROR_MONTH_DAY = 'Please enter a valid date';
export const FUTURE_DATE_ERROR_MESSAGE = "Date of purchase can't be in the future.";
export const SECRET_MANAGER_CAPTCHA_KEYS = 'CaptchaKeys';
export const SECRETS_MANAGER_ERROR_MESSAGES = 'Unable to fetch secrets from Secret Manager';
export const CARD_TYPE_VALIDATION_MESSAGE = 'Card type is required';
export const EMPTY_LAST_FOUR_DIGIT_VALIDATION_MESSAGE = 'Last 4 digits of the card is required';
export const VALID_LAST_FOUR_DIGIT_MESSAGE = 'Please enter valid last 4 digits of the card.';
export const PURCHASE_DATE_VALIDATION_MESSAGE = 'Purchase date is required';
export const EMPTY_FIRST_NAME_VALIDATION_MESSAGE = 'Invalid first name';
export const EMPTY_LAST_NAME_VALIDATION_MESSAGE = 'Invalid last name';
export const BAD_REQUEST_MESSAGE = 'Bad Request';
export const CAPTCHA_VALIDATION_MESSAGE = 'Please solve the captcha before submitting the form';
export const EMPTY_PAYPAL_TXN_ID_VALIDATION = 'PayPal transaction Id is required.';
export const INVALID_TXN_ID_VALIDATION =
  'Please enter only last 4 digits of the PayPal transaction Id.';
export const BLANK_ERROR_MESSAGE = '';
export const PAYMENT_TYPE_PAYPAL = 'PAYPAL';
export const PAYMENT_TYPE_GOOGLE_PAY_APPLE_PAY = 'GOOGLE_PAY_OR_APPLE_PAY';
export const PAYMENT_TYPE_CREDIT_OR_DEBIT_CARD = 'CREDIT_OR_DEBIT';
export const PAYMENT_TYPE_NONE = 'NONE';

//API Urls
export const API_BASE_URL = '/find-tickets';
export const SECRET_API = `${API_BASE_URL}/api/captcha-secrets`;
export const USER_EXISTS_API = `${API_BASE_URL}/api/user-exists`;
export const FIND_TICKETS_API = `${API_BASE_URL}/api/find-tickets`;
export const SEND_EMAIL_API = `${API_BASE_URL}/api/send-email`;
export const BARCODE_API = `${API_BASE_URL}/api/barcode`;
export const SEARCH_FORM_URL = `/search-form`;

//API Logging Constants

export const FIND_TICKETS_LOGGING = '[FindTickets]';
export const SEND_EMAIL_LOGGING = '[SendEmail]';
export const USER_EXISTS_LOGGING = '[UserExists]';
export const EMBEDDED_METRICS_NAMESPACE = 'FindMyTicketAppTestDashboard';
export const EMBEDDED_METRICS_SERVER_ERROR_METRIC_NAME = 'ServerError';
export const EMBEDDED_METRICS_CLIENT_ERROR_METRIC_NAME = 'ClientError';
export const EMBEDDED_METRICS_GRPC_SERVICE_ERROR_METRIC_NAME = 'GrpcServiceError';
// Service API Resource Constants
export const ORDER_SERVICE_BATCH_GET_ORDER_API = '/order_service/batch_get_order';
export const BARCODE_SERVICE_GET_TICKETS_API = '/barcode_service/get_tickets';

// Service Client Names
export const ORDER_SERVICE_CLIENT_NAME = 'OrderService';
export const BARCODE_SERVICE_CLIENT_NAME = 'BarcodeService';

// E2E / Captcha bypass
export const E2E_BYPASS_HEADER = 'x-eb-e2e-bypass';

// Captcha bypass secret resolution (Secrets Manager)
export const CAPTCHA_BYPASS_SECRET_NAME_ENV = 'CAPTCHA_BYPASS_SECRET_NAME';
export const CAPTCHA_BYPASS_SECRET_ARN_ENV = 'CAPTCHA_BYPASS_SECRET_ARN';
export const SECRET_MANAGER_CAPTCHA_BYPASS_NAME = 'CaptchaBypassSecret';

//Secret Manager Constants
export const SPLIT_API_KEY_IDENTITY_SECRET_NAME = 'splitAPIKeyIdentity';
export const SECRET_MANAGER_ERROR_MESSAGE = 'Failed to retrieve Secret from Secret Manager';
export const SECRET_NOT_FOUND_ERROR_MESSAGE = 'Failed to fetch Secret value';
export const SECRET_RETRIEVED_SUCCESSFULLY_MESSAGE =
  'Successfully retrieved secret from Secrets Manager.';

//Split Constants
export const SPLIT_WORKSPACE_NAME_IDENTITY = 'identity';
export const AUTH0_FEAUTRE_FLAG_NAME = 'enable_auth0_universal_login';

// Common domain emails
export const COMMON_DOMAIN_EMAILS: { [x: string]: string } = {
  'gmail.com': 'https://gmail.com/',
  'yahoo.com': 'https://mail.yahoo.com/',
  'hotmail.com': 'https://outlook.live.com/',
  'outlook.com': 'https://outlook.live.com/',
  'aol.com': 'https://mail.aol.com/',
  'icloud.com': 'https://www.icloud.com/mail',
};
